var _path, _circle, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#d86a82",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    id: "faq",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H7a5,5,0,0,0-5,5v9a5,5,0,0,0,5,5h.38l1.73,3.45a1.007,1.007,0,0,0,1.6.26L14.41,24H25a5,5,0,0,0,5-5V10A5,5,0,0,0,25,5Zm1.71,13.71a1.014,1.014,0,0,1-1.42,0l-.4-.4A4.426,4.426,0,0,1,22.5,19,4.5,4.5,0,1,1,27,14.5a4.426,4.426,0,0,1-.69,2.39l.4.4A1.008,1.008,0,0,1,26.71,18.71Zm-14.79-.32a1,1,0,0,1-1.84-.78l3-7a1,1,0,0,1,1.84,0l3,7a1,1,0,0,1-.53,1.31A1.046,1.046,0,0,1,17,19a1,1,0,0,1-.92-.61L15.48,17H12.52ZM5,11a1,1,0,0,1,1-1H9a1,1,0,0,1,0,2H7v2H9a1,1,0,0,1,0,2H7v2a1,1,0,0,1-2,0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 14.5,
    r: 2.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13.37 15 14.63 15 14 13.54 13.37 15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.5f2e5dfd4c826c75162a6c0e3f9f6075.svg";
export { ForwardRef as ReactComponent };